import { createComponent } from "utils/libExtend/createComponent";

import { ControlCellProps } from "./ControlCell.props";
import { SControlCell } from "./ControlCellStyled/SControlCell.styled";

export const ControlCell = createComponent<ControlCellProps>("ControlCell", (props) => {
  const { cell, service } = props;

  const onClick = (): void => {
    service.controller.switchCell(cell);
  };
  return (
    <SControlCell active={cell.active} onClick={onClick}>
      {cell.title}
    </SControlCell>
  );
});
